import { processSteps } from "./data";

export const Process = () => (
    <section id="process" className="bg-white py-20 sm:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-2xl mx-auto text-center mb-14">
                <p className="text-xs font-bold uppercase tracking-[0.22em] text-teal-600 mb-4">How It Works</p>
                <h2 className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">
                    Your Visit, Made Simple
                </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8" data-testid="process-steps">
                {processSteps.map((s, i) => (
                    <div key={s.num} className="relative text-center md:text-left" data-testid={`process-step-${i + 1}`}>
                        <span className="block text-[88px] leading-none font-bold text-teal-600/10 select-none font-heading" aria-hidden="true">
                            {s.num}
                        </span>
                        <div className="-mt-8">
                            <span className="hidden md:block absolute top-10 right-0 w-12 border-t-2 border-dashed border-teal-200 last:hidden" aria-hidden="true" />
                            <h3 className="text-xl font-semibold text-slate-900">{s.title}</h3>
                            <p className="mt-2.5 text-sm leading-relaxed text-slate-500 max-w-xs mx-auto md:mx-0">{s.desc}</p>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    </section>
);
